import {getLayout} from '../../../components/OrderLayout'
import {lookupStorageKey} from '../../../apollo/cache'
import {useSessionStorageState} from '../../../utils/useSessionStorageState'
import H2 from '../../../components/headings/H2'
import {OrderItem} from '../../../components/OrderItem'
import useOrderItem from '../../../hooks/useOrderItem'
import React, {useEffect, useState} from 'react'
import { fetchCustomAirFreshenerProduct, createCartWithLines } from '../../../apollo/shopifyApi'
import {useRouter} from 'next/router'
import {CheckIcon, XIcon} from '@heroicons/react/solid'
import {Loading} from '../../../components/Loading'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import ShadowBox from '../../../components/layout/ShadowBox'
import Button from '../../../components/Button'
import Subtitle from '../../../components/headings/Subtitle'


const IncDinc = styled.button([
  tw`relative inline-flex items-center px-2 py-1 border bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500`,
])

const initialState = {
  orderNumber: '',
  email: '',
  order: '',
}

const isSSR = typeof window === 'undefined'

interface StateType {}

const Reorder = ({shQuantity}) => {  
  // const router = useRouter()
  const [status, setStatus] = useState('idle') // idle, pending, resolved, rejected
  const [orderItems, setOrderItems] = useState()
  // console.log(checkout, 'checkoutreorder')
  const [checkoutUrl, setCheckoutUrl] = useState('')
  const [loading, setLoading] = useState(false)
  const [checkedItems, setCheckedItems] = useState([])
  const [state] = useSessionStorageState(
    lookupStorageKey,
    initialState,
  )
  const [cartItems, setCartItems] = useState([])
  const [newScent, setnewScent] = useState([])

  // Safari detection utility
  const isSafari = () => {
    if (typeof window === 'undefined') return false
    const userAgent = window.navigator.userAgent
    const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(userAgent)
    const isIOS = /iPad|iPhone|iPod/.test(userAgent)
    const isWebKit = 'WebkitAppearance' in document.documentElement.style
    
    return isSafariBrowser || isIOS || (isWebKit && !/Chrome/.test(userAgent))
  }

  // console.log(cartItems)

  const handleAddToCart = (event, clickedItem) => {
    console.log('add')
    setCartItems(prev => {
      // 1. Is the item already added in the cart?
      const isItemInCart = prev.find(
        item => +item.id === +clickedItem.id,
      )

      if (isItemInCart) {
        return prev.map(item =>
          +item.id === +clickedItem.id
            ? {...item, quantity: item.quantity + 1}
            : item,
        )
      }
      // First time the item is added
      return [...prev, { ...clickedItem, quantity: 1 }];
    })
  }

  const handleToCart = (event, clickedItem) => {    
    setCartItems(prev => {
      // 1. Is the item already added in the cart?
      const isItemInCart = prev.find(
        item => +item.id === +clickedItem.id,
      )

      if (isItemInCart) {
        return prev.map(item =>
          +item.id === +clickedItem.id
            ? {
                ...item,
                quantity: Number(event.target.value),
              }
            : item,
        )
      }
      // First time the item is added
      return [...prev, {...clickedItem}]
    })
  }

  const handleRemoveFromCart = (event, id: number) => {
    console.log('remove')
    setCartItems(prev =>
      prev.reduce((ack, item) => {
        if (item.id === id) {
          if (item.quantity === 1) return ack
          return [...ack, {...item, quantity: item.quantity - 1}]
        } else {
          return [...ack, item]
        }
      }, []),
    )
  }

  let lines = []

  const {order} = state
  const {order_items} = order
  // console.log(order, 'orderinreorder')

  if (!state.order) return null

  function buildCartLines(cartItems, variants) {
    return cartItems.map(cartItem => {
      let scent = cartItem.variation_list.find(v => v.key === 'Scent').value
      scent = scent === 'Island Breeze' ? 'Island Breeze (most popular)' : scent
  
      let crop = cartItem.variation_list.find(v => v.key === 'Crop').value
      if (!['Just The Head(s)', 'Entire Body(s)', 'Do Not Crop', 'Just The Car'].includes(crop)) {
        crop = 'Other'
      }
  
      const variant = variants.find(v => v.title === `${scent} / ${crop}`)
      if (!variant) throw new Error(`Variant not found for ${scent} / ${crop}`)
  
      const image = cartItem.metadata.find(v => v.key === 'image')?.value || ''
  
      return {
        merchandiseId: variant.id,
        quantity: cartItem.quantity,
        attributes: [{ key: 'Uploaded Image', value: image }],
      }
    })
  }
  
  async function buyIt() {
    // setLoading(true)
    setStatus('pending')

    try {
      const product = await fetchCustomAirFreshenerProduct()
      const variants = product.variants.edges.map(edge => edge.node)
  
      const lines = buildCartLines(cartItems, variants)
      const cart = await createCartWithLines(lines)
  
      setStatus('resolved')
  
      const checkoutUrl = cart.checkoutUrl.replace('whifffresheners.myshopify', 'dangleit')
      setCheckoutUrl(checkoutUrl)
      
      // Safari-compatible popup handling
      if (isSafari()) {
        console.log('Safari detected, using redirect method')
        // For Safari, redirect current window to avoid popup blocking
        // Give user a choice to stay or go to checkout
        if (window.confirm('Redirecting to checkout page. Click OK to continue or Cancel to stay on this page.')) {
          try {
            console.log('Attempting redirect to:', checkoutUrl)
            window.location.href = checkoutUrl
          } catch (redirectError) {
            console.error('Redirect failed, trying alternative method:', redirectError)
            // Fallback: try to open in same window
            window.location.assign(checkoutUrl)
          }
        }
      } else {
        // For other browsers, try to open popup
        try {
          const popup = window.open(checkoutUrl, '_blank')
          
          // Check if popup was blocked
          if (!popup || popup.closed || typeof popup.closed === 'undefined') {
            // Popup was blocked, redirect current window instead
            console.warn('Popup blocked, redirecting current window')
            window.location.href = checkoutUrl
          } else {
            // Popup opened successfully, focus it
            popup.focus()
          }
        } catch (popupError) {
          console.warn('Popup blocked, redirecting current window:', popupError)
          // Fallback: redirect current window
          window.location.href = checkoutUrl
        }
      }
    } catch (err) {
      console.error('Checkout error:', err)
      setStatus('rejected')
    }
  }

  const ReorderItem = ({item, cartItems}) => {
    const [checked, setnewchecked] = useState(
      cartItems?.find(i => +i.id === +item.id),
    )
    
    if (
      item.variation_list.find(v => v.key === 'Replace-Refund')
    )
      return null
    // const checked = cartItems?.find(i => +i.id === +item.id)
    const styles = {
      backgroundColor: '#F3F4F6',
    }

    const ItemScent = item.variation_list?.find(
      v => v.key === 'Scent',
    )?.value

    const getScantAvailiblity = newScent?.find(
      v => v.value === ItemScent,
    )

    // useEffect(() => {
    //   setnewQuantites(checked?.quantity)
    // }, [])
    return (
      <div
        tw="!px-3 !py-3 md:!px-5 md:!py-5"
        className="border-box item-outer reorder-box"
        // css={[
        //   tw`mt-4 -mx-2 p-2 hover:bg-gray-100`,
        //   checked && tw`bg-gray-100`,
        // ]}
      >
        {getScantAvailiblity == 'undefined' ? (
          <div className="banner-text">Scent Discontinued</div>
        ) : null}
        {/* <input
          type="checkbox"
          css={[
            tw`opacity-0 absolute h-8 w-8`,
            checked && tw`pointer-events-none`,
          ]}
          value={item.id}
          id={`item-${item.id}`}
          name={`item-${item.id}`}
          checked={checked}
          onChange={event => {
            checked
              ? handleRemoveFromCart(event, item.id)
              : handleAddToCart(event, item)
          }}
        /> */}
        <label
          className="reorder-flex-mob"
          tw="relative flex items-start md:items-center cursor-pointer flex-wrap justify-between mb-0!"
          htmlFor={`item-${item.id}`}
          onClick={() => {
            return false
          }}
        >
          <OrderItem
          shQuantity={shQuantity}
            item={item}
            hasPrice={true}
            showQuantity={false}
            setOrderItems={setOrderItems}
            // order_items={order_items}
            states={state}
            referenceSection='reorder_section'
          >
            {/* {checked ? ( */}
            <>
              <div className="qty-box card-content-right" tw="mt-3!">
                <span
                  className="qty-box-reorder"
                  tw="place-self-start inline-flex lg:pt-0 lg:mr-0 lg:mt-0 md:mt-0 mt-0 lg:relative absolute top-0 right-0 w-full"
                >
                  <IncDinc
                    className="inc-btn border-gray"
                    type="button"
                    tw="rounded-l-md"
                    onClick={e =>
                      handleRemoveFromCart(e, item.id)
                    }
                  >
                    -
                  </IncDinc>
                  {/* <span
                    className="qty-input"
                    tw="-ml-px w-8 relative inline-flex items-center px-2 py-1 border bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                  >
                    {checked?.quantity || 0}
                  </span> */}
                  <input
                    // autoFocus
                    className="qty-input qty-input-cm border-gray"
                    tw="-ml-px w-8 relative inline-flex items-center px-2 py-1 border bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                    value={checked?.quantity || 0}
                    onChange={e => {
                      // setnewchecked({
                      //   ...checked,
                      //   quantity: Number(e.target.value),
                      // })
                      handleToCart(e, item)
                    }}
                  />
                  <IncDinc
                    className="dec-btn border-gray"
                    type="button"
                    tw="rounded-r-md -ml-px "
                    onClick={e => handleAddToCart(e, item)}
                  >
                    +
                  </IncDinc>
                </span>
              </div>
              {/* <CheckIcon tw="mr-3 h-6 w-6" /> */}
            </>
            {/* ) : null}*/}
          </OrderItem>
        </label>
      </div>
    )
  }

  return (
    <>
      {/* <ShadowBox> */}
      <div className="item-box px-0">
        {/* <H2>Items:</H2>
        <Subtitle>Ordered items and their details.</Subtitle> */}

        {order_items.map(item => (
          <ReorderItem
            key={item.id}
            item={item}
            cartItems={cartItems}
          />
        ))}
      </div>
      {/* </ShadowBox> */}

      <div tw="grid place-items-center mx-auto text-center mt-4">
        <button
          className="brand-btn submit-btn"
          key="verify-address"
          type="submit"
          css={[
            status === 'success' && tw`bg-green-600`,
            status === 'rejected' && tw`bg-red-600`,
          ]}
          onClick={buyIt}
          disabled={status === 'pending' || !cartItems.length}
        >
          Add To Cart
          <span className="position-text">
            {status === 'pending' ? <Loading tw="ml-2" /> : null}
            {/* {status === 'resolved' ? (
              <CheckIcon tw="pl-2 h-5 w-5" />
            ) : null}
            {status === 'rejected' ? (
              <XIcon tw="pl-2 h-5 w-5" />
            ) : null} */}
          </span>
        </button>

        {status === 'resolved' && checkoutUrl && (
          <div tw="mt-3 text-center">
            <div tw="text-green-600 font-medium mb-2">✓ Items added to cart successfully!</div>
            <a
              href={checkoutUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="brand-btn submit-btn"
              tw="inline-flex items-center justify-center"
            >
              Continue to Checkout
            </a>
          </div>
        )}
        {status === 'rejected' && (
          <Subtitle tw="mt-1">
            We were unable to add your item(s) to the cart.
          </Subtitle>
        )}
        {/* {checkoutUrl && (
          <a
            href={checkoutUrl}
            target="_blank"
            rel="noreferrer"
            className="brand-btn mt-3"
          >
            View Cart
          </a>
        )} */}
      </div>
    </>
  )
}

Reorder.getLayout = getLayout
Reorder.displayName = 'Reorder'

export default Reorder
